export const state = {
    selectedCustomer: null,
    selectedCompany: null,

};

export const mutations = {
    SET_SELECTED_CUSTOMER(state, payload) {
        state.selectedCustomer = payload;
    },
    SET_SELECTED_COMPANY(state, payload) {
        state.selectedCompany = payload;
    },
};

export const actions = {
    setSelectedCustomer({ commit }, payload) {
        commit('SET_SELECTED_CUSTOMER', payload)
    },
    setSelectedCompany({ commit }, payload) {
        commit('SET_SELECTED_COMPANY', payload)
    },
}